/**
 * Конфигурация feature flags для управления функциональностью приложения
 */
export interface FeatureFlags {
  /** Включить маскированный телефон с Mango */
  enableMaskedPhone: boolean;

  /** Включить A/B тестирование на страницах */
  enableAbTestingPages: boolean;

  /**
   * Версия текстов FAQ на странице API: 1 — легаси-тексты, 2 — `*V2`-ключи,
   * 3 — `*V3` и т.д. Если перевода нужной версии нет на локали, используется
   * ближайшая доступная более старая версия (см. resolveVersionedTranslationKey).
   */
  apiFaqContentVersion: number;

  /** Версия текстов стандартного вопроса howToGetAccess в FaqSection (см. apiFaqContentVersion) */
  howToGetAccessContentVersion: number;
}

/**
 * Дефолтные значения feature flags
 */
export const defaultFeatureFlags: FeatureFlags = {
  enableMaskedPhone: false,
  enableAbTestingPages: true,
  apiFaqContentVersion: 1,
  howToGetAccessContentVersion: 1,
};

/**
 * Получить feature flags для текущего окружения
 */
export const getFeatureFlags = (): FeatureFlags => {
  return {
    ...defaultFeatureFlags,
  };
};
